const { STATUS, CHECK_ID } = require('../constants');

// CORS is verified purely against the merchant's declared allowlist from the
// diagnostics API. A live browser probe was removed: ottu_pg only grants CORS
// on non-exempt paths when the request carries a `merchant-id` header matching a
// WebSecurityPolicy (api/sdk/handlers.py), so a bare cross-origin fetch to the
// PG root can never succeed and would report `blocked` for every merchant —
// including correctly-whitelisted ones. The config diff is the authoritative
// source; the probe only ever produced false warnings.
// Reduce a value to a bare `host` or `host:port`, stripping any scheme. The
// merchant allowlist declares hostnames (optionally with a port, e.g.
// `localhost:9000`) while shopOrigin is a full origin from
// window.location.origin (`scheme://host[:port]`), so both sides are normalised
// to the same shape before comparison — a raw string match would false-negative
// every correctly-whitelisted merchant on the scheme alone.
function toHostKey(value) {
  const bare = String(value || '').replace(/^[a-z][a-z0-9+.-]*:\/\//i, '');
  try {
    const { hostname, port } = new URL(`http://${bare}`);
    return port ? `${hostname}:${port}` : hostname;
  } catch (e) {
    return bare;
  }
}

async function runCorsCheck(ctx, apiConfig) {
  if (!apiConfig) {
    return { id: CHECK_ID.CORS, status: STATUS.INFO, detail: 'diagnostics API unavailable — check skipped', evidence: { observedOutcome: 'unavailable' } };
  }
  const allowlist = (apiConfig.web && apiConfig.web.cors_allowed_origins) || [];
  const originHost = toHostKey(ctx.shopOrigin);
  const originHostname = originHost.split(':')[0];
  const inList = allowlist.some((entry) => {
    const entryHost = toHostKey(entry);
    // Match on host:port when the allowlist entry is port-qualified, otherwise
    // on hostname alone so a bare-host entry accepts any port.
    return entryHost === originHost || entryHost === originHostname;
  });

  const status = inList ? STATUS.PASS : STATUS.FAIL;
  const detail = inList
    ? 'shopOrigin is whitelisted'
    : 'shopOrigin is not in the merchant CORS allowlist';

  return { id: CHECK_ID.CORS, status, detail, evidence: { originUsed: ctx.shopOrigin, allowlist } };
}

module.exports = { runCorsCheck };
